// Protocol Buffers for ML Services
// 
// Package: guardianai.v1.ml

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/ml/ml.proto (package guardianai.v1.ml, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/ml/ml.proto.
 */
export const file_guardianai_v1_ml_ml: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.ml.DetectFraudRequest
 */
export type DetectFraudRequest = Message<"guardianai.v1.ml.DetectFraudRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * "email", "phone", "user", "transaction"
   *
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: map<string, string> features = 3;
   */
  features: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.ml.DetectFraudRequest
 */
export type DetectFraudRequestJson = {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * "email", "phone", "user", "transaction"
   *
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;

  /**
   * @generated from field: map<string, string> features = 3;
   */
  features?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.ml.DetectFraudRequest.
 * Use `create(DetectFraudRequestSchema)` to create a new message.
 */
export const DetectFraudRequestSchema: GenMessage<DetectFraudRequest, {jsonType: DetectFraudRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 0);

/**
 * @generated from message guardianai.v1.ml.DetectFraudResponse
 */
export type DetectFraudResponse = Message<"guardianai.v1.ml.DetectFraudResponse"> & {
  /**
   * @generated from field: bool is_fraud = 1;
   */
  isFraud: boolean;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence: number;

  /**
   * @generated from field: string fraud_type = 3;
   */
  fraudType: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.RiskFactor risk_factors = 4;
   */
  riskFactors: RiskFactor[];

  /**
   * @generated from field: string model_version = 5;
   */
  modelVersion: string;
};

/**
 * @generated from message guardianai.v1.ml.DetectFraudResponse
 */
export type DetectFraudResponseJson = {
  /**
   * @generated from field: bool is_fraud = 1;
   */
  isFraud?: boolean;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string fraud_type = 3;
   */
  fraudType?: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.RiskFactor risk_factors = 4;
   */
  riskFactors?: RiskFactorJson[];

  /**
   * @generated from field: string model_version = 5;
   */
  modelVersion?: string;
};

/**
 * Describes the message guardianai.v1.ml.DetectFraudResponse.
 * Use `create(DetectFraudResponseSchema)` to create a new message.
 */
export const DetectFraudResponseSchema: GenMessage<DetectFraudResponse, {jsonType: DetectFraudResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 1);

/**
 * @generated from message guardianai.v1.ml.RiskFactor
 */
export type RiskFactor = Message<"guardianai.v1.ml.RiskFactor"> & {
  /**
   * @generated from field: string factor = 1;
   */
  factor: string;

  /**
   * @generated from field: double weight = 2;
   */
  weight: number;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * @generated from message guardianai.v1.ml.RiskFactor
 */
export type RiskFactorJson = {
  /**
   * @generated from field: string factor = 1;
   */
  factor?: string;

  /**
   * @generated from field: double weight = 2;
   */
  weight?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string description = 3;
   */
  description?: string;
};

/**
 * Describes the message guardianai.v1.ml.RiskFactor.
 * Use `create(RiskFactorSchema)` to create a new message.
 */
export const RiskFactorSchema: GenMessage<RiskFactor, {jsonType: RiskFactorJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 2);

/**
 * @generated from message guardianai.v1.ml.AnalyzePatternRequest
 */
export type AnalyzePatternRequest = Message<"guardianai.v1.ml.AnalyzePatternRequest"> & {
  /**
   * @generated from field: repeated string entity_ids = 1;
   */
  entityIds: string[];

  /**
   * @generated from field: string pattern_type = 2;
   */
  patternType: string;
};

/**
 * @generated from message guardianai.v1.ml.AnalyzePatternRequest
 */
export type AnalyzePatternRequestJson = {
  /**
   * @generated from field: repeated string entity_ids = 1;
   */
  entityIds?: string[];

  /**
   * @generated from field: string pattern_type = 2;
   */
  patternType?: string;
};

/**
 * Describes the message guardianai.v1.ml.AnalyzePatternRequest.
 * Use `create(AnalyzePatternRequestSchema)` to create a new message.
 */
export const AnalyzePatternRequestSchema: GenMessage<AnalyzePatternRequest, {jsonType: AnalyzePatternRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 3);

/**
 * @generated from message guardianai.v1.ml.AnalyzePatternResponse
 */
export type AnalyzePatternResponse = Message<"guardianai.v1.ml.AnalyzePatternResponse"> & {
  /**
   * @generated from field: bool pattern_detected = 1;
   */
  patternDetected: boolean;

  /**
   * @generated from field: string pattern_name = 2;
   */
  patternName: string;

  /**
   * @generated from field: double confidence = 3;
   */
  confidence: number;

  /**
   * @generated from field: repeated string involved_entities = 4;
   */
  involvedEntities: string[];

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * @generated from message guardianai.v1.ml.AnalyzePatternResponse
 */
export type AnalyzePatternResponseJson = {
  /**
   * @generated from field: bool pattern_detected = 1;
   */
  patternDetected?: boolean;

  /**
   * @generated from field: string pattern_name = 2;
   */
  patternName?: string;

  /**
   * @generated from field: double confidence = 3;
   */
  confidence?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated string involved_entities = 4;
   */
  involvedEntities?: string[];

  /**
   * @generated from field: string description = 5;
   */
  description?: string;
};

/**
 * Describes the message guardianai.v1.ml.AnalyzePatternResponse.
 * Use `create(AnalyzePatternResponseSchema)` to create a new message.
 */
export const AnalyzePatternResponseSchema: GenMessage<AnalyzePatternResponse, {jsonType: AnalyzePatternResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 4);

/**
 * @generated from message guardianai.v1.ml.RiskScoreRequest
 */
export type RiskScoreRequest = Message<"guardianai.v1.ml.RiskScoreRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;
};

/**
 * @generated from message guardianai.v1.ml.RiskScoreRequest
 */
export type RiskScoreRequestJson = {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;
};

/**
 * Describes the message guardianai.v1.ml.RiskScoreRequest.
 * Use `create(RiskScoreRequestSchema)` to create a new message.
 */
export const RiskScoreRequestSchema: GenMessage<RiskScoreRequest, {jsonType: RiskScoreRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 5);

/**
 * @generated from message guardianai.v1.ml.RiskScoreResponse
 */
export type RiskScoreResponse = Message<"guardianai.v1.ml.RiskScoreResponse"> & {
  /**
   * 0-100
   *
   * @generated from field: double score = 1;
   */
  score: number;

  /**
   * "low", "medium", "high", "critical"
   *
   * @generated from field: string risk_level = 2;
   */
  riskLevel: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.RiskFactor factors = 3;
   */
  factors: RiskFactor[];

  /**
   * @generated from field: int64 last_updated = 4;
   */
  lastUpdated: bigint;
};

/**
 * @generated from message guardianai.v1.ml.RiskScoreResponse
 */
export type RiskScoreResponseJson = {
  /**
   * 0-100
   *
   * @generated from field: double score = 1;
   */
  score?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * "low", "medium", "high", "critical"
   *
   * @generated from field: string risk_level = 2;
   */
  riskLevel?: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.RiskFactor factors = 3;
   */
  factors?: RiskFactorJson[];

  /**
   * @generated from field: int64 last_updated = 4;
   */
  lastUpdated?: string;
};

/**
 * Describes the message guardianai.v1.ml.RiskScoreResponse.
 * Use `create(RiskScoreResponseSchema)` to create a new message.
 */
export const RiskScoreResponseSchema: GenMessage<RiskScoreResponse, {jsonType: RiskScoreResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 6);

/**
 * @generated from message guardianai.v1.ml.GetModelInfoRequest
 */
export type GetModelInfoRequest = Message<"guardianai.v1.ml.GetModelInfoRequest"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;
};

/**
 * @generated from message guardianai.v1.ml.GetModelInfoRequest
 */
export type GetModelInfoRequestJson = {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId?: string;
};

/**
 * Describes the message guardianai.v1.ml.GetModelInfoRequest.
 * Use `create(GetModelInfoRequestSchema)` to create a new message.
 */
export const GetModelInfoRequestSchema: GenMessage<GetModelInfoRequest, {jsonType: GetModelInfoRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 7);

/**
 * @generated from message guardianai.v1.ml.ModelInfoResponse
 */
export type ModelInfoResponse = Message<"guardianai.v1.ml.ModelInfoResponse"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * "active", "training", "deprecated"
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 last_trained = 7;
   */
  lastTrained: bigint;

  /**
   * @generated from field: double accuracy = 8;
   */
  accuracy: number;
};

/**
 * @generated from message guardianai.v1.ml.ModelInfoResponse
 */
export type ModelInfoResponseJson = {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string version = 3;
   */
  version?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * "active", "training", "deprecated"
   *
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 last_trained = 7;
   */
  lastTrained?: string;

  /**
   * @generated from field: double accuracy = 8;
   */
  accuracy?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.ml.ModelInfoResponse.
 * Use `create(ModelInfoResponseSchema)` to create a new message.
 */
export const ModelInfoResponseSchema: GenMessage<ModelInfoResponse, {jsonType: ModelInfoResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 8);

/**
 * @generated from message guardianai.v1.ml.ListModelsRequest
 */
export type ListModelsRequest = Message<"guardianai.v1.ml.ListModelsRequest"> & {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter: string;
};

/**
 * @generated from message guardianai.v1.ml.ListModelsRequest
 */
export type ListModelsRequestJson = {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter?: string;
};

/**
 * Describes the message guardianai.v1.ml.ListModelsRequest.
 * Use `create(ListModelsRequestSchema)` to create a new message.
 */
export const ListModelsRequestSchema: GenMessage<ListModelsRequest, {jsonType: ListModelsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 9);

/**
 * @generated from message guardianai.v1.ml.ListModelsResponse
 */
export type ListModelsResponse = Message<"guardianai.v1.ml.ListModelsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.ml.ModelInfoResponse models = 1;
   */
  models: ModelInfoResponse[];
};

/**
 * @generated from message guardianai.v1.ml.ListModelsResponse
 */
export type ListModelsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.ml.ModelInfoResponse models = 1;
   */
  models?: ModelInfoResponseJson[];
};

/**
 * Describes the message guardianai.v1.ml.ListModelsResponse.
 * Use `create(ListModelsResponseSchema)` to create a new message.
 */
export const ListModelsResponseSchema: GenMessage<ListModelsResponse, {jsonType: ListModelsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 10);

/**
 * @generated from message guardianai.v1.ml.ModelMetricsRequest
 */
export type ModelMetricsRequest = Message<"guardianai.v1.ml.ModelMetricsRequest"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: string period = 2;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.ml.ModelMetricsRequest
 */
export type ModelMetricsRequestJson = {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId?: string;

  /**
   * @generated from field: string period = 2;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.ml.ModelMetricsRequest.
 * Use `create(ModelMetricsRequestSchema)` to create a new message.
 */
export const ModelMetricsRequestSchema: GenMessage<ModelMetricsRequest, {jsonType: ModelMetricsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 11);

/**
 * @generated from message guardianai.v1.ml.ModelMetricsResponse
 */
export type ModelMetricsResponse = Message<"guardianai.v1.ml.ModelMetricsResponse"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: double accuracy = 2;
   */
  accuracy: number;

  /**
   * @generated from field: double precision = 3;
   */
  precision: number;

  /**
   * @generated from field: double recall = 4;
   */
  recall: number;

  /**
   * @generated from field: double f1_score = 5;
   */
  f1Score: number;

  /**
   * @generated from field: int64 total_predictions = 6;
   */
  totalPredictions: bigint;

  /**
   * @generated from field: int64 correct_predictions = 7;
   */
  correctPredictions: bigint;

  /**
   * @generated from field: double false_positive_rate = 8;
   */
  falsePositiveRate: number;

  /**
   * @generated from field: double false_negative_rate = 9;
   */
  falseNegativeRate: number;
};

/**
 * @generated from message guardianai.v1.ml.ModelMetricsResponse
 */
export type ModelMetricsResponseJson = {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId?: string;

  /**
   * @generated from field: double accuracy = 2;
   */
  accuracy?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double precision = 3;
   */
  precision?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double recall = 4;
   */
  recall?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double f1_score = 5;
   */
  f1Score?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 total_predictions = 6;
   */
  totalPredictions?: string;

  /**
   * @generated from field: int64 correct_predictions = 7;
   */
  correctPredictions?: string;

  /**
   * @generated from field: double false_positive_rate = 8;
   */
  falsePositiveRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double false_negative_rate = 9;
   */
  falseNegativeRate?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.ml.ModelMetricsResponse.
 * Use `create(ModelMetricsResponseSchema)` to create a new message.
 */
export const ModelMetricsResponseSchema: GenMessage<ModelMetricsResponse, {jsonType: ModelMetricsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 12);

/**
 * @generated from message guardianai.v1.ml.PredictRequest
 */
export type PredictRequest = Message<"guardianai.v1.ml.PredictRequest"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: map<string, string> features = 2;
   */
  features: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.ml.PredictRequest
 */
export type PredictRequestJson = {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId?: string;

  /**
   * @generated from field: map<string, string> features = 2;
   */
  features?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.ml.PredictRequest.
 * Use `create(PredictRequestSchema)` to create a new message.
 */
export const PredictRequestSchema: GenMessage<PredictRequest, {jsonType: PredictRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 13);

/**
 * @generated from message guardianai.v1.ml.PredictResponse
 */
export type PredictResponse = Message<"guardianai.v1.ml.PredictResponse"> & {
  /**
   * @generated from field: string prediction = 1;
   */
  prediction: string;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence: number;

  /**
   * @generated from field: map<string, double> class_probabilities = 3;
   */
  classProbabilities: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.ml.PredictResponse
 */
export type PredictResponseJson = {
  /**
   * @generated from field: string prediction = 1;
   */
  prediction?: string;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: map<string, double> class_probabilities = 3;
   */
  classProbabilities?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };
};

/**
 * Describes the message guardianai.v1.ml.PredictResponse.
 * Use `create(PredictResponseSchema)` to create a new message.
 */
export const PredictResponseSchema: GenMessage<PredictResponse, {jsonType: PredictResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 14);

/**
 * @generated from message guardianai.v1.ml.BatchPredictRequest
 */
export type BatchPredictRequest = Message<"guardianai.v1.ml.BatchPredictRequest"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.PredictRequest requests = 2;
   */
  requests: PredictRequest[];
};

/**
 * @generated from message guardianai.v1.ml.BatchPredictRequest
 */
export type BatchPredictRequestJson = {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId?: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.PredictRequest requests = 2;
   */
  requests?: PredictRequestJson[];
};

/**
 * Describes the message guardianai.v1.ml.BatchPredictRequest.
 * Use `create(BatchPredictRequestSchema)` to create a new message.
 */
export const BatchPredictRequestSchema: GenMessage<BatchPredictRequest, {jsonType: BatchPredictRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 15);

/**
 * @generated from message guardianai.v1.ml.BatchPredictResponse
 */
export type BatchPredictResponse = Message<"guardianai.v1.ml.BatchPredictResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.ml.PredictResponse responses = 1;
   */
  responses: PredictResponse[];

  /**
   * @generated from field: int64 processing_time_ms = 2;
   */
  processingTimeMs: bigint;
};

/**
 * @generated from message guardianai.v1.ml.BatchPredictResponse
 */
export type BatchPredictResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.ml.PredictResponse responses = 1;
   */
  responses?: PredictResponseJson[];

  /**
   * @generated from field: int64 processing_time_ms = 2;
   */
  processingTimeMs?: string;
};

/**
 * Describes the message guardianai.v1.ml.BatchPredictResponse.
 * Use `create(BatchPredictResponseSchema)` to create a new message.
 */
export const BatchPredictResponseSchema: GenMessage<BatchPredictResponse, {jsonType: BatchPredictResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 16);

/**
 * @generated from message guardianai.v1.ml.ExplainRequest
 */
export type ExplainRequest = Message<"guardianai.v1.ml.ExplainRequest"> & {
  /**
   * @generated from field: string prediction_id = 1;
   */
  predictionId: string;
};

/**
 * @generated from message guardianai.v1.ml.ExplainRequest
 */
export type ExplainRequestJson = {
  /**
   * @generated from field: string prediction_id = 1;
   */
  predictionId?: string;
};

/**
 * Describes the message guardianai.v1.ml.ExplainRequest.
 * Use `create(ExplainRequestSchema)` to create a new message.
 */
export const ExplainRequestSchema: GenMessage<ExplainRequest, {jsonType: ExplainRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 17);

/**
 * @generated from message guardianai.v1.ml.ExplainResponse
 */
export type ExplainResponse = Message<"guardianai.v1.ml.ExplainResponse"> & {
  /**
   * @generated from field: string prediction_id = 1;
   */
  predictionId: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.FeatureContribution contributions = 2;
   */
  contributions: FeatureContribution[];

  /**
   * @generated from field: string summary = 3;
   */
  summary: string;
};

/**
 * @generated from message guardianai.v1.ml.ExplainResponse
 */
export type ExplainResponseJson = {
  /**
   * @generated from field: string prediction_id = 1;
   */
  predictionId?: string;

  /**
   * @generated from field: repeated guardianai.v1.ml.FeatureContribution contributions = 2;
   */
  contributions?: FeatureContributionJson[];

  /**
   * @generated from field: string summary = 3;
   */
  summary?: string;
};

/**
 * Describes the message guardianai.v1.ml.ExplainResponse.
 * Use `create(ExplainResponseSchema)` to create a new message.
 */
export const ExplainResponseSchema: GenMessage<ExplainResponse, {jsonType: ExplainResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 18);

/**
 * @generated from message guardianai.v1.ml.FeatureContribution
 */
export type FeatureContribution = Message<"guardianai.v1.ml.FeatureContribution"> & {
  /**
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * @generated from field: double contribution = 2;
   */
  contribution: number;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * @generated from message guardianai.v1.ml.FeatureContribution
 */
export type FeatureContributionJson = {
  /**
   * @generated from field: string feature = 1;
   */
  feature?: string;

  /**
   * @generated from field: double contribution = 2;
   */
  contribution?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string value = 3;
   */
  value?: string;
};

/**
 * Describes the message guardianai.v1.ml.FeatureContribution.
 * Use `create(FeatureContributionSchema)` to create a new message.
 */
export const FeatureContributionSchema: GenMessage<FeatureContribution, {jsonType: FeatureContributionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_ml_ml, 19);

/**
 * @generated from service guardianai.v1.ml.MLService
 */
export const MLService: GenService<{
  /**
   * Fraud detection
   *
   * @generated from rpc guardianai.v1.ml.MLService.DetectFraud
   */
  detectFraud: {
    methodKind: "unary";
    input: typeof DetectFraudRequestSchema;
    output: typeof DetectFraudResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.ml.MLService.AnalyzePattern
   */
  analyzePattern: {
    methodKind: "unary";
    input: typeof AnalyzePatternRequestSchema;
    output: typeof AnalyzePatternResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.ml.MLService.GetRiskScore
   */
  getRiskScore: {
    methodKind: "unary";
    input: typeof RiskScoreRequestSchema;
    output: typeof RiskScoreResponseSchema;
  },
  /**
   * Model management
   *
   * @generated from rpc guardianai.v1.ml.MLService.GetModelInfo
   */
  getModelInfo: {
    methodKind: "unary";
    input: typeof GetModelInfoRequestSchema;
    output: typeof ModelInfoResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.ml.MLService.ListModels
   */
  listModels: {
    methodKind: "unary";
    input: typeof ListModelsRequestSchema;
    output: typeof ListModelsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.ml.MLService.GetModelMetrics
   */
  getModelMetrics: {
    methodKind: "unary";
    input: typeof ModelMetricsRequestSchema;
    output: typeof ModelMetricsResponseSchema;
  },
  /**
   * Predictions
   *
   * @generated from rpc guardianai.v1.ml.MLService.Predict
   */
  predict: {
    methodKind: "unary";
    input: typeof PredictRequestSchema;
    output: typeof PredictResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.ml.MLService.BatchPredict
   */
  batchPredict: {
    methodKind: "unary";
    input: typeof BatchPredictRequestSchema;
    output: typeof BatchPredictResponseSchema;
  },
  /**
   * Explanation
   *
   * @generated from rpc guardianai.v1.ml.MLService.ExplainPrediction
   */
  explainPrediction: {
    methodKind: "unary";
    input: typeof ExplainRequestSchema;
    output: typeof ExplainResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_ml_ml, 0);

